import { put, call, fork, all, select, takeLatest } from "redux-saga/effects";
import moment from 'moment';
import { connect, Connect } from "react-redux";
import { withRouter } from 'react-router';
import { instanceOf } from "prop-types";
import * as queryString from 'query-string';

export const getURLPath = (serverURL = null) => {
    //debugger;
    if (typeof window !== 'undefined') {
        //debugger;
        return window.location.pathname;
    }
    else {
        //debugger;
        return serverURL;
    }
};


export const getDomain = (serverURL) => {
    var sRet = "";
    var iDot = 0;
    if (typeof window !== "undefined") {
        sRet = window.location.hostname;
        iDot = sRet.indexOf(".");
        if (iDot > 0) {
            sRet = sRet.substring(iDot + 1);
        }
        return sRet;
    }
    else {
        if (serverURL) {
            //console.log("getDomain staritng with: " + serverURL);
            var iStart = serverURL.indexOf("//");
            //console.log("getDomain iStart = " + iStart);
            var iEnd = serverURL.indexOf("/", iStart + 2);
            var iEnd2 = serverURL.indexOf(":", iStart + 2);
            if (iEnd2 > 0) {
                if (iEnd2 < iEnd) {
                    iEnd = iEnd2;
                }
            }
            if (iEnd < 1) {
                iEnd = serverURL.length + 1;
            }
            //console.log("getDomain iEnd = " + iEnd);
            sRet = serverURL.substring(iStart + 2, iEnd);
            //console.log("getDomain parsed = " + sRet + "  Parsed length = " + sRet.length);
            iDot = sRet.indexOf(".");
            if (iDot > 0) {
                sRet = sRet.substring(iDot + 1);
            }
            return sRet;
        }
    }
};

export const splitIntoRowsOf = (arrayObj, iMaxPerRow) => {
    if (arrayObj === null || typeof arrayObj === "undefined") { return null; }
    //debugger;
    try {
        var newArray = [];
        //debugger;
        for (var i = 0; i < arrayObj.length; i = i + iMaxPerRow) {
            //debugger;
            newArray.push(arrayObj.slice(i, i + iMaxPerRow));
            //debugger;
        }
        return newArray;
    }
    catch (ex) {
        //debugger;
        return arrayObj;
    }
};


export const mergeArrays = (array1, array2) => {
    if (typeof array1 === "undefined") { array1 = []; }
    if (typeof array2 === "undefined") { array2 = []; }
    var ret = array1.concat(array2.filter(function (item) { return array1.indexOf(item) < 0; }));
    return ret;
};

export const getUnhydratedProviderNPIs = (arrayNPI, arrayHydratedProviders) => {
    //debugger;
    if (typeof arrayNPI === "undefined") { arrayNPI = []; }
    if (typeof arrayHydratedProviders === "undefined") { arrayHydratedProviders = []; }
    var ret = arrayNPI.filter(function (item) { return typeof arrayHydratedProviders.find(function (prov) { return prov.npi === item; }) === "undefined"; });
    if (ret.length > 0) {
        //debugger;
    }
    return ret;
};

export const getFormattedDate = (date) => {
    if (!isValidDate(date)) { return null; }
    var year = date.getFullYear();

    var month = (1 + date.getMonth()).toString();
    month = month.length > 1 ? month : '0' + month;

    var day = date.getDate().toString();
    day = day.length > 1 ? day : '0' + day;

    return month + '/' + day + '/' + year;
};

export const isAndroid = () => {
    if (typeof navigator !== 'undefined' && /android/i.test(navigator.userAgent)) {
        return true;
    }
    return false;
};

export const isIos = () => {
    if (typeof navigator !== 'undefined' && /iPhone|iPad|iPod/i.test(navigator.userAgent))
        return true;
    return false;
};

export const isIPad = () => {
    if (typeof navigator !== 'undefined' && /iPad/i.test(navigator.userAgent))
        return true;
    return false;
};


export const isMobile = () => {
    return isAndroid() || isIos() || isIPad();
}


export const isValidZipCode = (zipCode) => {
    try {
        zipCode = zipCode || "";
        const regex = /^\d{1,5}$/; //ZipCode is 5 digit long and only number
        return regex.test(zipCode) && zipCode.length === 5;
    }
    catch (e) {
        return false;
    }
};

export const isValidDate = (thisDate) => {
    try {
        if (typeof thisDate === "string") {
            const workDate = new Date(thisDate);
            return (typeof thisDate !== "undefined") && (thisDate !== null) && (thisDate !== "") && (!isNaN(workDate.valueOf()));
        }
        else {
            return (typeof thisDate !== "undefined") && (thisDate !== null) && (thisDate !== "") && (!isNaN(thisDate.valueOf()));
        }
    }
    catch (e) {
        return false;
    }
};

export const isFutureDate = (thisDate) => {
    try {
        const dateValue = new Date(thisDate);
        var currentDate = new Date();
        return isValidDate(thisDate) && dateValue > currentDate;
    }
    catch (e) {
        return false;
    }
};

export const isEmptyString = (thisString) => {
    try {
        return (thisString === null || thisString.trim() === "");
    }
    catch (e) {
        return true;
    }
};

export const isValidEmail = (thisEmail) => {
    try {
        thisEmail = thisEmail || "";
        const regex = /(.+)@(.+){2,}\.(.+){2,}/;
        return regex.test(thisEmail);
    }
    catch (e) {
        return false;
    }
};

export const isValidPassword = (thisPassword) => {
    try {
        thisPassword = thisPassword || "";
        const hasCapital = (/([A-Z]+)/g.test(thisPassword)) ? true : false;
        const hasLower = (/([a-z]+)/g.test(thisPassword)) ? true : false;
        const hasSpecial = (/[!@#$ %^&* (),.? ":{}|<>/[`~|\]\\0-9]/g.test(thisPassword)) ? true : false;
        const hasReqLength = thisPassword.length > 7 ? true : false;
        return hasCapital && hasLower && hasSpecial && hasReqLength;
    }
    catch (e) {
        return false;
    }
};

export const isObjectEmpty = (thisObject) => {
    try {
        return Object.keys(thisObject).length === 0;
    }
    catch (e) {
        return true;
    }
};


// Caution... don't use this on big objects... the intention is for use copying nested initial state objects
export const deepCopy = (src) => {
    let target = {};
    for (let prop in src) {
        if (src.hasOwnProperty(prop)) {
            if (!isObjectEmpty(src[prop])) {
                target[prop] = deepCopy(src[prop]);
            }
            else {
                target[prop] = src[prop];
            }

        }
    }
    return target;
};


// Here is a simple wrapper function to protect your Sagas against 401s, 404s or 500s, where we might want to handle those conditions more gracefully
export const safeCall = (saga, ...args) => call(function* () {
    try {
        //debugger;
        return { err: false, result: yield call(saga, ...args) };
    } catch (err) {
        //debugger;
        return { err: true, result: err };
    }
});


export const dateAsUTCString = (oDate) => {
    return padLeftZeros(oDate.getUTCFullYear().toString(), 4) + "-" +
        padLeftZeros(oDate.getUTCMonth().toString() + 1, 2) + "-" +
        padLeftZeros(oDate.getUTCDate().toString(), 2) + "T" +
        padLeftZeros(oDate.getUTCHours().toString(), 2) + ":" +
        padLeftZeros(oDate.getUTCMinutes().toString(), 2) + ":" +
        padLeftZeros(oDate.getUTCSeconds().toString(), 2) + "Z";

};


export const padLeftZeros = (sString, iLen) => {
    return padLeft(sString, iLen, '0');
};


export const padLeft = (sString, iLen, sPadChar) => {
    while (sString.length < iLen) {
        sString = sPadChar + sString;
    }
    return sString;
};



export const trimComma = (sString) => {
    if (sString && sString.length > 0) {
        sString = sString.trim();
        sString = sString.replace(/(^,)|(,$)/g, "");
    }
    return sString;
};


export const lCase = (sString) => {
    if (sString) {
        sString = sString.toLowerCase();
    }
    return sString;
};


export const usersAreTheSame = (primaryUser, myChartProxyUser) => {
    try {
        if (primaryUser && !myChartProxyUser) {
            return true;
        }
        if (primaryUser && myChartProxyUser) {
            if (primaryUser.externalId === myChartProxyUser.externalId && lCase(primaryUser.myChartId) === lCase(myChartProxyUser.myChartId)) {
                return true;
            }
        }
    }
    catch (ex) {

    }
    return false;
};


export const formatTimeUTCToCST = (value) => {
    if (value) {
        return moment.utc(value).tz('America/Chicago').format('h:mm A');
    }
    else {
        return value;
    }
};


export const timeformat = (date) => {
    try {
        if (date) {
            var h = date.getHours();
            var m = date.getMinutes();
            var x = h >= 12 ? 'PM' : 'AM';
            h = h % 12;
            h = h ? h : 12;
            m = m < 10 ? '0' + m : m;
            var mytime = h + ':' + m + ' ' + x;
            return mytime;
        }
    } catch (e) {
    }
}

export const calculateDateInDays = (date1, date2) => {
    try {
        var diffc = date1.getTime() - date2.getTime();
        var days = Math.round(Math.abs(diffc / (1000 * 60 * 60 * 24)));
        return days;
    }
    catch (e) {
    }
}

export const formatDate = (date) => {
    try {
        if (date) {
            var month = '' + (date.getMonth() + 1),
                day = '' + date.getDate(),
                year = date.getFullYear();

            if (month.length < 2) month = '0' + month;
            if (day.length < 2) day = '0' + day;
            month = getMonthName(month);
            return [month, day].join(' ');
        }
    } catch (e) {
        //debugger;
    }
}

export const formatDateForSafari = (date) => {
    try {
        if (date) {
            return date.replace(/-/g, '/').replace('T', ' ');
        }
    } catch (e) {
        //debugger;
    }
};

export const getRootRef = (oObject) => {
    if (oObject.getWrappedInstance) {
        return getRootRef(oObject.getWrappedInstance() || oObject);
    }
    return oObject;
};


export const toJSDate = (dateTime, dateFormat) => {
    try {
        if (dateTime) {
            if (typeof window !== 'undefined') {
                return dateFormat ? moment(dateTime, dateFormat).toDate() : moment(dateTime).toDate();
            } else {
                return new Date(dateTime);
            }
        }
    } catch (e) {
    }
}

export const getDateFormats = () => {
    return ['YYYY-MM-DD HH:mm:ss', 'YYYY-M-D HH:mm:ss', 'YYYY-MM-D HH:mm:ss', 'YYYY-M-DD HH:mm:ss'];
};


export const addMonths = (dateTime, iMonths) => {
    let momentDate = moment(dateTime);
    return momentDate.add(iMonths, 'months').toDate();
}

export const addDays = (dateTime, iDays) => {
    let momentDate = moment(dateTime);
    return momentDate.add(iDays, 'days').toDate();
}


export const dateSimpleFormat = (dateTime) => {
    let momentDate = moment(dateTime);
    return momentDate.format("YYYY-MM-DD");
}


export const getMonthFullName = (monthValue, format) => {
    try {
        if (monthValue) {
            if (typeof window !== 'undefined') {
                return format ? moment(monthValue, 'MM').format(format) : moment(monthValue, 'MM').format('MMMM');
            }
        }
        return ""
    } catch (e) {
        return "";
    }
};

export const getMonthName = (month) => {
    switch (month) {
        case "01":
            return "JAN";
            break;
        case "02":
            return "FEB";
            break;
        case "03":
            return "MAR";
            break;
        case "04":
            return "APR";
            break;
        case "05":
            return "MAY";
            break;
        case "06":
            return "JUN";
            break;
        case "07":
            return "JUL";
            break;
        case "08":
            return "AUG";
            break;
        case "09":
            return "SEP";
            break;
        case "10":
            return "OCT";
            break;
        case "11":
            return "NOV";
            break;
        case "12":
            return "DEC";
            break;
        default:
            return "";
            break;
    }
}

export const isDateAfter = (date, compareToDate) => {
    return moment(date).isAfter(compareToDate);
}


//let isBlocked = false;

//export const block = (historyObject, prompt = false) => {
//    debugger;

//    let historyScope = historyObject.listen["[[Scopes]]"];
//    debugger;
//    const unblock = historyScope[0].transitionManager.setPrompt(prompt);

//    if (!isBlocked) {
//        historyScope[0].checkDOMListeners(1);
//        isBlocked = true;
//    }

//    return () => {
//        if (this.isBlocked) {
//            this.isBlocked = false;
//            historyScope[0].checkDOMListeners(-1);
//        }

//        return unblock();
//    };
//}

export const getStates = () => {
    return [
        { value: 'AL', label: 'Alabama' },
        { value: 'AK', label: 'Alaska' },
        { value: 'AZ', label: 'Arizona' },
        { value: 'AR', label: 'Arkansas' },
        { value: 'CA', label: 'California' },
        { value: 'CO', label: 'Colorado' },
        { value: 'CT', label: 'Connecticut' },
        { value: 'DE', label: 'Delaware' },
        { value: 'FL', label: 'Florida' },
        { value: 'GA', label: 'Georgia' },
        { value: 'HI', label: 'Hawaii' },
        { value: 'ID', label: 'Idaho' },
        { value: 'IL', label: 'Illinois' },
        { value: 'IN', label: 'Indiana' },
        { value: 'IA', label: 'Iowa' },
        { value: 'KS', label: 'Kansas' },
        { value: 'KY', label: 'Kentucky' },
        { value: 'LA', label: 'Louisiana' },
        { value: 'ME', label: 'Maine' },
        { value: 'MD', label: 'Maryland' },
        { value: 'MA', label: 'Massachusetts' },
        { value: 'MI', label: 'Michigan' },
        { value: 'MN', label: 'Minnesota' },
        { value: 'MS', label: 'Mississippi' },
        { value: 'MO', label: 'Missouri' },
        { value: 'MT', label: 'Montana' },
        { value: 'NE', label: 'Nebraska' },
        { value: 'NV', label: 'Nevada' },
        { value: 'NH', label: 'New Hampshire' },
        { value: 'NJ', label: 'New Jersey' },
        { value: 'NM', label: 'New Mexico' },
        { value: 'NY', label: 'New York' },
        { value: 'NC', label: 'North Carolina' },
        { value: 'ND', label: 'North Dakota' },
        { value: 'OH', label: 'Ohio' },
        { value: 'OK', label: 'Oklahoma' },
        { value: 'OR', label: 'Oregon' },
        { value: 'PA', label: 'Pennsylvania' },
        { value: 'RI', label: 'Rhode Island' },
        { value: 'SC', label: 'South Carolina' },
        { value: 'SD', label: 'South Dakota' },
        { value: 'TN', label: 'Tennessee' },
        { value: 'TX', label: 'Texas' },
        { value: 'UT', label: 'Utah' },
        { value: 'VT', label: 'Vermont' },
        { value: 'VA', label: 'Virginia' },
        { value: 'WA', label: 'Washington' },
        { value: 'WV', label: 'West Virginia' },
        { value: 'WI', label: 'Wisconsin' },
        { value: 'WY', label: 'Wyoming' },
        { value: 'AS', label: 'American Samoa' },
        { value: 'DC', label: 'District of Columbia' },
        { value: 'FM', label: 'Federated States of Micronesia' },
        { value: 'GU', label: 'Guam' },
        { value: 'MH', label: 'Marshall Islands' },
        { value: 'MP', label: 'Northern Mariana Islands' },
        { value: 'PW', label: 'Palau' },
        { value: 'PR', label: 'Puerto Rico' },
        { value: 'VI', label: 'Virgin Islands' }
    ];
};

export const getACOs = () => {
    return [
        { id: 'AEBH', label: 'Aetna' },
        { id: 'AEFI', label: 'Aetna' },
        { id: 'AEMA', label: 'Aetna' },
        { id: 'AESI', label: 'Aetna' },
        { id: 'BCBS', label: 'Blue Cross Blue Shield' },
        { id: 'BCDT', label: 'Blue Cross Blue Shield' },
        { id: 'CGCT', label: 'Cigna' },
        { id: 'CGNT', label: 'Cigna' },
        { id: 'DART', label: 'Healthscope' },
        { id: 'HUMA', label: 'Humana' },
        { id: 'MSSP', label: 'Medicare' },
        { id: 'UHAC', label: 'UnitedHealth' }
    ];
};

export const isSafari = () => {
    let isSafari = (typeof navigator !== 'undefined' && /^((?!chrome|android).)*safari/i.test(navigator.userAgent)) ? true : false;
    return isSafari;
}

export const dateStringFormat = (dateTime, formatStr) => {
    if (typeof window !== 'undefined' && dateTime) {
        let momentDate = moment(dateTime);
        let fmtStr = formatStr ? formatStr : "YYYY-MM-DD";
        return momentDate.format(fmtStr);
    }
    return;
};

export const validateManualDate = (dateTime, formatStr) => {
    if (typeof window !== 'undefined' && dateTime) {
        let isValid = moment(dateTime, formatStr, true).isValid();
        return isValid;
    }
    return false;
};

export const isMobileQuery = (location) => {
    if (typeof location !== 'undefined' && location) {      
        const params = queryString.parse(location.search);             
        if (params && params.mobile === 'true') {
            return true;
        }
        else {
            let isMobileUrl = typeof window !== 'undefined' && window.location && window.location.href.indexOf('mobile=true') > 0 ? true : false;           
            return isMobileUrl;
        }
    }
    return false;
};

export const isMobileQueryDisabled = (location) => {
    if (typeof location !== 'undefined' && location) {
        const params = queryString.parse(location.search);
        if (params && params.mobile === 'false') {
            return true;
        }
        else {
            let isMobileUrl = typeof window !== 'undefined' && window.location && window.location.href.indexOf('mobile=false') > 0 ? true : false;
            return isMobileUrl;
        }
    }
    return false;
};

export const isRegistrationQuery = (location) => { //created seperate fof like the above isMobileQuery
    if (typeof location !== 'undefined' && location) {
        const params = queryString.parse(location.search);
        if (params && params.registration === 'true') {
            return true;
        }
    }
    return false;
};

export const isNewerVersion = (oldVer, newVer) => {
    if (oldVer && newVer) {
        const oldParts = oldVer.split('.');
        const newParts = newVer.split('.');
        for (var i = 0; i < newParts.length; i++) {
            const a = parseInt(newParts[i]) || 0;
            const b = parseInt(oldParts[i]) || 0;
            if (a > b) return true;
            if (a < b) return false;
        }
    }
    return false;
};

export const setFocus = (inputId, condition) => {
    if (typeof condition === 'undefined' || condition) {
        const input = document.querySelector('#' + inputId);
        if (input) {
            input.focus();
        }
    }
};

export const setItemToSessionStorage = (key, valueToSet) => {
    if (window && window.sessionStorage) {
        const value = window.sessionStorage.getItem(key);
        if (value === null || value !== valueToSet)
            window.sessionStorage.setItem(key, valueToSet);
    }
};

export const getItemFromSessionStorage = (key) => {
    if (window && window.sessionStorage)
        return window.sessionStorage.getItem(key);
};

export const clearItemFromSessionStorage = (key) => {
    if (window && window.sessionStorage)
        window.sessionStorage.removeItem(key);
};

export const clearItemFromSessionStorageWithStrContains = (key) => {
    if (window && window.sessionStorage && key) {
        for (let skey in window.sessionStorage) {
            if (window.sessionStorage.hasOwnProperty(skey) && skey && skey.indexOf(key) > -1) {
                window.sessionStorage.removeItem(skey);
            }
        }
    }
};

export const buildUrl = (domainRoot, urlPath) => {
    if (domainRoot.charAt(domainRoot.length - 1) !== "/") {
        domainRoot = domainRoot + "/";
    }
    if (urlPath.charAt(0) === "/") {
        urlPath = urlPath.substring(1);
    }
    return domainRoot + urlPath;
}

export const isBrowserIEOrEdge = () => {
    if (typeof navigator !== 'undefined' && /MSIE|Trident|Edge/i.test(navigator.userAgent))
        return true;
    return false;
};

export const linkPhoneNumber = (stringWithPhoneNumber) => {
    const regex = /.*(\d{3}\.\d{3}\.\d{4}).*/;
    const matchedPhoneNumber = stringWithPhoneNumber.match(regex) && stringWithPhoneNumber.match(regex)[1];
    const linkedPhoneNumber = `<a href="tel:${matchedPhoneNumber}">${matchedPhoneNumber}</a>`;
    if (matchedPhoneNumber)
        stringWithPhoneNumber = stringWithPhoneNumber.replace(matchedPhoneNumber, linkedPhoneNumber);
    return stringWithPhoneNumber;
};

export const fileToBase64 = (file) => {
    return new Promise(resolve => {
        var reader = new FileReader();
        // Read file content on file loaded event
        reader.onload = function (event) {
            const base64String = event.target.result.replace("data:", "").replace(/^.+,/, ""); // remove data url part
            resolve(base64String);
        };
        // Convert data to base64 
        reader.readAsDataURL(file);
    });
};

export const browserDetection = () => {
    if (typeof navigator !== 'undefined' && navigator && navigator.userAgent) {
        if (/Edge\/\d./i.test(navigator.userAgent)) {
            return "Edge";
        } else if (/MSIE|Trident/i.test(navigator.userAgent)) {
            return "IE";
        } else if (navigator.userAgent.indexOf("Firefox") > -1) {
            return 'Firefox';
        } else if (navigator.userAgent.indexOf("CriOS") > -1) { //Mobile IOS Chrome
            return 'Chrome'
        } else if (navigator.userAgent.indexOf("FxiOS") > -1) { //Mobile IOS Firefox
            return 'Firefox';
        } else if (navigator.userAgent.indexOf("edg") > -1) {
            return 'New Edge';
        } else if ((navigator.userAgent.indexOf("Opera") > -1) || (navigator.userAgent.indexOf("OPR") > -1)) {
            return 'Opera';
        } else if (navigator.userAgent.indexOf("SamsungBrowser") > -1) {
            return 'Samsung Internet';
        } else if ((navigator.userAgent.indexOf('Mozilla/5.0') > -1 && navigator.userAgent.indexOf('Android ') > -1 &&
            navigator.userAgent.indexOf('AppleWebKit') > -1) && (navigator.userAgent.indexOf('Version') > -1)) {
            return 'Android Native'; //Mobile Android default browser
        } else if (!(navigator.userAgent.indexOf("Chrome") > -1) && (navigator.userAgent.indexOf("Safari") > -1)) {
            return 'Safari';
        } else if (navigator.userAgent.indexOf("Chrome") > -1 && navigator.vendor && /Google Inc/.test(navigator.vendor)) {
            return 'Chrome';
        }
    }
    return '';
};

export const copyText = (text) => {
    if (!navigator.clipboard) {  //Edge browser does not support , so fallback added.
        fallbackCopyText(text);
        return;
    }
    navigator.clipboard.writeText(text).then(function () {
        console.log('Async: Copying to clipboard was successful!');
    }, function (err) {
        console.error('Async: Could not copy text: ', err);
    });
};

const fallbackCopyText = (text) => {
    const textArea = document.createElement("textarea");
    textArea.value = text;

    // Avoid scrolling to bottom
    textArea.style.top = "0";
    textArea.style.left = "0";
    textArea.style.position = "fixed";

    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();

    try {
        const successful = document.execCommand('copy');
        const msg = successful ? 'successful' : 'unsuccessful';
        console.log('Fallback: Copying text command was ' + msg);
    } catch (err) {
        console.error('Fallback: Oops, unable to copy', err);
    }

    document.body.removeChild(textArea);
};

// Reference : https://stackoverflow.com/questions/9514179/how-to-find-the-operating-system-version-using-javascript
export const getOSInfo = () => {
    var unknown = 'Unknown';
    //browser
    var nVer = navigator.appVersion;
    var nAgt = navigator.userAgent;

    // system
    var os = unknown;
    var clientStrings = [
        { s: 'Windows 3.11', r: /Win16/ },
        { s: 'Windows 95', r: /(Windows 95|Win95|Windows_95)/ },
        { s: 'Windows ME', r: /(Win 9x 4.90|Windows ME)/ },
        { s: 'Windows 98', r: /(Windows 98|Win98)/ },
        { s: 'Windows CE', r: /Windows CE/ },
        { s: 'Windows 2000', r: /(Windows NT 5.0|Windows 2000)/ },
        { s: 'Windows XP', r: /(Windows NT 5.1|Windows XP)/ },
        { s: 'Windows Server 2003', r: /Windows NT 5.2/ },
        { s: 'Windows Vista', r: /Windows NT 6.0/ },
        { s: 'Windows 7', r: /(Windows 7|Windows NT 6.1)/ },
        { s: 'Windows 8.1', r: /(Windows 8.1|Windows NT 6.3)/ },
        { s: 'Windows 8', r: /(Windows 8|Windows NT 6.2)/ },
        { s: 'Windows NT 4.0', r: /(Windows NT 4.0|WinNT4.0|WinNT|Windows NT)/ },
        { s: 'Windows ME', r: /Windows ME/ },
        { s: 'Android', r: /Android/ },
        { s: 'Open BSD', r: /OpenBSD/ },
        { s: 'Sun OS', r: /SunOS/ },
        { s: 'Linux', r: /(Linux|X11)/ },
        { s: 'iOS', r: /(iPhone|iPad|iPod)/ },
        { s: 'Mac OS X', r: /Mac OS X/ },
        { s: 'Mac OS', r: /(MacPPC|MacIntel|Mac_PowerPC|Macintosh)/ },
        { s: 'QNX', r: /QNX/ },
        { s: 'UNIX', r: /UNIX/ },
        { s: 'BeOS', r: /BeOS/ },
        { s: 'OS/2', r: /OS\/2/ },
        { s: 'Search Bot', r: /(nuhk|Googlebot|Yammybot|Openbot|Slurp|MSNBot|Ask Jeeves\/Teoma|ia_archiver)/ }
    ];
    for (var id in clientStrings) {
        var cs = clientStrings[id];
        if (cs.r.test(nAgt)) {
            os = cs.s;
            break;
        }
    }
    var osVersion = unknown;

    try {
        if (/Windows/.test(os)) {
            osVersion = /Windows (.*)/.exec(os);
            if (osVersion)
                osVersion = osVersion[1] || 0;
            os = 'Windows';
        }

        switch (os) {
            case 'Mac OS X':
                osVersion = /Mac OS X (\d+)_(\d+)_?(\d+)?/.exec(nAgt);
                if (osVersion) {
                    osVersion = `${osVersion[1] || 0}.${osVersion[2] || 0}.${osVersion[3] || 0}`;
                };
                break;

            case 'Android':
                osVersion = /Android ([\.\_\d]+)/.exec(nAgt);
                if (osVersion)
                    osVersion = osVersion[1] || 0;
                break;

            case 'iOS':
                osVersion = /OS (\d+)_(\d+)_?(\d+)?/.exec(nVer);
                if (osVersion)
                    osVersion = [parseInt(osVersion[1] || 0, 10), parseInt(osVersion[2] || 0, 10), parseInt(osVersion[3] || 0, 10)];
                break;
        }

        return {
            os: os,
            osVersion: osVersion
        };
    }

    catch (error) {
        return { os: "", osVersion: "" };
    }
}
